import { AssetType } from '@nemuru-eng/js-api-client';

import { Text } from '../../../../../../shared/components/Text';

export const AllowedAssetTypesOptions = Object.values(AssetType).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
